// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const render = () => {
    const reactRoot = document.getElementById('react-root');
    /*
     * prevent auto translation for localizejs extension
     * https://locussh.atlassian.net/browse/ES-20325
     */
    reactRoot.setAttribute('notranslate', true);
    ReactDOM.render(<App />, reactRoot);
};

render();
